import assert from "utils/assert";
import axios from "../axios";
import RestfulService from "./RestfulService";

/**
 * A comment on a target. See Comment.java
 */
export class Comment {
  targetId;
  targetTable;
  message;
  createdBy;
  createdAt;
  lastModifiedDate;
  lastModifiedBy;
}

/**
 * TODO switch to this (BUT needs testing!)
 */
const commentService = new RestfulService("/comment");
export default commentService;

/**
 * @returns {Promise<Comment>}
 */
export function apiGetComment(commentId) {
  return axios.get(`/comment/${commentId}`).then(({ data }) => data);
}

/**
 * @param {string} targetTable
 * @param {string} targetId HACK can be "ALL" to get all comments for a target table
 * @returns {Promise<Comment[]>}
 */
export function apiListComments(targetTable, targetId) {
  return axios.get(`/comment/list/${targetTable}/${targetId}`).then(({ data }) => data);
}

/**
 *
 *
 * @param {Comment} comment
 * @returns {Promise<Comment>}
 */
export function apiNewComment(comment) {
  return axios.post(`/comment`, comment).then(({ data }) => data);
}

export function apiUpdateComment(comment) {
  assert(comment.id, "comment.id is required");
  return axios.post(`/comment/${comment.id}`, comment).then(({ data }) => data);
}

/**
 *
 * @param {Comment} comment
 */
export function apiDeleteComment(comment) {
  assert(comment.id, "comment.id is required");
  console.log("deleting comment", comment);
  return axios.delete(`/comment/${comment.id}`);
}
